import { Stack } from '@mui/material';

import { MaxPriceFilter } from './max-price-filter';
import { MinPriceFilter } from './min-price-filter';

export const MinMaxPriceFilter = () => (
    <Stack direction="row" gap={3}>
        <MinPriceFilter />
        <MaxPriceFilter />
    </Stack>
);
